define('drops/errorHandling/errorHandling',[
    'jquery',
    'lq/drop',
    'lq/style'
], function ($, Drop, Style) {
    'use strict';

    function ErrorHandling(options) {
        Drop.call(this, $('<div/>'), options);

        this.$element
	        .addClass('boxToBorderSize')
            .css({
                overflowY: 'auto',
                overflowX: 'auto'
            });

        Style.renderStyles(this);
    };

    Drop.extend(ErrorHandling, Drop);

    ErrorHandling.typeName = 'ErrorHandling';

    ErrorHandling.prototype.preRender = function () {
        this.applyPosition();
        this.hide();
    };

    ErrorHandling.prototype.onError = function (errorArgs) {
        this.showMessage(errorArgs.message);
        
        this.piping.busyIndicator.forceHide();
        errorArgs.handled = true;
    };

    ErrorHandling.prototype.showMessage = function (message) {
        this.$element.html(message.replace(/\n/g, '<br />'));
        this.show();
    };

    ErrorHandling.prototype.clearValue = function () {
        this.$element.html('');
        this.hide();
    };

    ErrorHandling.prototype.setValue = function (update) {
        this.showMessage(update.value);
    };

    return ErrorHandling;
});
